export enum ExternalSystemSyncResult {
Success,
PartialSuccess,
Failed,
InProgress,
}
